import { StorageDataService } from 'src/app/helpers/storageData.service';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProfileDataDTO } from '../dto/account/profile.dto';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private storageDataService: StorageDataService
  ) {
    this.profile = this.storageDataService.getProfileStorage();
  }

  profile: ProfileDataDTO;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.authService.logout();
        }
        const error = err.error || err.statusText;
        return throwError(error);
      })
    );
  }
}
